import { useState } from 'react';
import { Plus } from 'lucide-react';
import { useAuth } from '../../auth/AuthProvider';
import { CreateDialog } from './CreateDialog';
import './creation.css';

export function EmptyProject({ projectId }: { projectId: number }) {
  const { user } = useAuth(), [open, setOpen] = useState(false);
  const project = user?.projects?.find(p => p.id === projectId);
  return <section className="sc-empty"><h1>{project?.title}</h1><h2>Добавьте первый регламент</h2><p>Например, shots или assets. Затем добавьте этапы работы и ассеты вручную или загрузите Excel.</p>{user?.canCreate && <button className="sc-primary" onClick={() => setOpen(true)}><Plus size={18}/>Добавить регламент</button>}{open && <CreateDialog kind="regulation" projectId={projectId} onClose={() => setOpen(false)}/>}</section>;
}
